import { render, staticRenderFns } from "./RevenueInstructions.vue?vue&type=template&id=6fb88e8a&scoped=true"
import script from "./RevenueInstructions.vue?vue&type=script&lang=js"
export * from "./RevenueInstructions.vue?vue&type=script&lang=js"
import style0 from "./RevenueInstructions.vue?vue&type=style&index=0&id=6fb88e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb88e8a",
  null
  
)

export default component.exports